import React, { useRef, useState } from 'react'
import { Button, InterfaceCopyIcon, Tooltip, TooltipContent, TooltipTrigger } from '@grammarly/design-system'

import { copyTooltipDismissTime } from '../constants'
import { useTool } from '../tool-context'

export const ToolCopyButton: React.FC = () => {
  const { outputTextToCopy, isLoading } = useTool()
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const toolTipDismissRef = useRef<NodeJS.Timeout | null>(null)

  if (outputTextToCopy === null || isLoading) {
    return null
  }

  const copyText = () => {
    if (toolTipDismissRef.current) {
      clearTimeout(toolTipDismissRef.current)
    }
    void navigator?.clipboard.writeText(outputTextToCopy)
    setIsTooltipOpen(true)
    toolTipDismissRef.current = setTimeout(() => setIsTooltipOpen(false), copyTooltipDismissTime)
  }

  return (
    <Tooltip open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
      <TooltipTrigger asChild>
        <Button variant="secondary" size="small" onClick={copyText} iconStart={InterfaceCopyIcon}>
          Copy text
        </Button>
      </TooltipTrigger>
      <TooltipContent root={null}>Copied!</TooltipContent>
    </Tooltip>
  )
}
